<template>
  <!-- eslint-disable max-len -->
  <main class="u-container">
    <section>
      <h1
        class="font-bold"
      >
        Official USPS<sup>®</sup> Change-of-Address
      </h1>
    </section>
    <section
      v-if="needsConfirmation"
      class="mt-5"
    >
      <p class="font-bold">
        To successfully submit your request, click the button below to confirm and file your Change-of-Address order.
      </p>
      <p class="mt-2">
        Date of Transaction: {{ coaCompletedDate | formatDateStr }}<br>
        Name: {{ firstName }} {{ lastName }}<br>
        Move Type: {{ moverType }}<br>
        Move Effective Date: {{ startDate | formatDateStr }}<br>
      </p>
      <button
        id="confirm-mcoa"
        class="c-btn mt-2"
        @click="confirm"
      >
        Confirm
      </button>
    </section>
    <section
      v-else
      class="mt-5"
    >
      <p class="font-bold">
        Your Change-of-Address has been confirmed.
      </p>
    </section>
  </main>
</template>

<script>
import { format, parse } from 'date-fns';
import pageView from '../../mixins/pageView';

export default {
  name: 'DesktopMilitaryConfirmation',
  filters: {
    formatDateStr(dateStr) {
      if (!dateStr) return '';

      return format(parse(dateStr, 'yyyy-MM-dd', new Date()), 'MM/dd/yyyy');
    },
  },
  mixins: [pageView],
  data() {
    return {
      coa: {},
      mover: {},
      needsConfirmation: true,
    };
  },
  computed: {
    coaCompletedDate() {
      return this.coa?.completedDate;
    },
    moverType() {
      return this.coa?.moverType;
    },
    startDate() {
      return this.coa?.startDate;
    },
    firstName() {
      return this.mover?.firstName;
    },
    lastName() {
      return this.mover?.lastName;
    },
  },
  async mounted() {
    const { coaUUID } = this.$route.params;
    this.$coa.coaUUID = coaUUID;
    this.pageView();
    await this.hydrateCOA();
    await this.hydrateMover();
  },
  methods: {
    async hydrateCOA() {
      const { uuid, ...coa } = await this.$coa.coaGet() || [];

      if (uuid) {
        this.coa = coa;
      }
    },
    async hydrateMover() {
      const mover = await this.$coa.personGet('mover');
      if (mover) {
        this.mover = mover;
      }
    },
    async confirm() {
      await this.$coa.confirmMCOA(this.coa);
      this.needsConfirmation = false;
    },
  },
};
</script>
